// 邮编查询结果过滤：
// 接口按距离返回最近的若干条门店，如果其中有 postcode 与输入完全匹配的门店，
// 只保留绝对匹配项（隐藏其余）；没有绝对匹配时返回接口原列表。
export const filterExactPostcodeMatches = (stores, postcode) => {
  if (!Array.isArray(stores) || stores.length === 0) return stores;

  const normalized = String(postcode || '')
    .trim()
    .toUpperCase();
  const exactMatches = stores.filter(
    // 邮编字段名兼容 postCode / postalCode 两种（待后端确认后统一）
    (store) =>
      String(store.postCode ?? store.postalCode ?? '')
        .trim()
        .toUpperCase() === normalized
  );

  return exactMatches.length > 0 ? exactMatches : stores;
};
